import SkyClickPlayer from './SkyClickPlayer';
import ComponentWrapper from "../wrappers/ComponentWrapper";

/**
 * This component is a div layer over the whole player (except control-bar)
 * This layer will also disappear automatically on user inactivity.
 * So every custom control elements can appended on this element
 */
export default class ControlLayer extends ComponentWrapper{

    // Define default name of component. It used for component instantiation by string (player.addChild('componentName')).
    // So we have the ability to load the component instance by name (player.getChild('componentName').
    public name_ = 'ControlLayer';

    constructor(skyClickPlayer:SkyClickPlayer,options:Object = {}){
        super(skyClickPlayer,options)
    }

    public buildCSSClass(){
        // Add our className to the returned className
        return 'vjs-control-layer ' + super.buildCSSClass();
    }

    createEl() {
        let props = {
            className: this.buildCSSClass()
        };

        // create viewer div
        const el = super.createEl('div', props);

        return el;
    }



}


// WEBPACK FOOTER //
// ./src/app/components/custom/ControlLayer.ts